import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Seo from "@/components/Seo";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-24 text-center sm:px-6 lg:px-8">
      <Seo title="Payment cancelled | CA HVAC Direct" description="Your payment was cancelled." />
      <XCircle className="mx-auto h-14 w-14 text-slate-400" />
      <h1 className="mt-5 font-heading text-3xl font-black tracking-tight text-slate-900">Payment Cancelled</h1>
      <p className="mt-3 text-slate-600">No payment was taken. Your cart is still saved if you'd like to try again.</p>
      <div className="mt-8 flex justify-center gap-3">
        <Button asChild className="rounded-sm bg-sky-700 hover:bg-sky-800"><Link to="/cart">Return to Cart</Link></Button>
        <Button asChild variant="outline" className="rounded-sm border-slate-300"><Link to="/shop">Continue Shopping</Link></Button>
      </div>
    </div>
  );
}
